import React from 'react';
import './IdeaGenerationPreview.css';

/**
 * Idea Generation (Socratic) UI for the shared Preview panel.
 */
export default function IdeaGenerationPreview({
  active = false,
  stageIndex = 0,
  stages = [],
  businessIdea = {},
  onRestart,
}) {
  const stage = stages[stageIndex] || null;
  const answered = Object.keys(businessIdea || {}).filter((k) =>
    k.startsWith(`stage${stageIndex}`)
  ).length;
  const totalInStage = stage?.questions?.length || 0;
  const currentQ =
    stage?.questions?.[Math.min(answered, Math.max(0, totalInStage - 1))] ||
    (active ? 'Share your idea in the chat…' : 'Start Idea Generation from the menu.');

  const allAnswers = Object.entries(businessIdea || {}).map(([key, value]) => ({
    key,
    value: String(value || ''),
  }));

  return (
    <div className="idea-preview" role="region" aria-label="Idea Generation in Preview panel">
      <div className="idea-preview-toolbar">
        <div className="idea-preview-brand">
          <span aria-hidden="true">💡</span>
          <span>Idea Generation</span>
        </div>
        {active && (
          <button type="button" className="idea-preview-btn" onClick={onRestart}>
            Restart
          </button>
        )}
      </div>

      {!active ? (
        <div className="idea-preview-empty">
          Open Idea Generation from the menu to coach your idea here — answer questions in chat and watch progress in this preview.
        </div>
      ) : (
        <>
          <div className="idea-preview-stage">
            <div className="idea-preview-stage-label">
              Stage {stageIndex + 1} of {stages.length}
            </div>
            <div className="idea-preview-stage-name">{stage?.stage || 'Ideation'}</div>
            <div className="idea-preview-progressbar" aria-hidden="true">
              <div
                className="idea-preview-progressbar-fill"
                style={{
                  width: `${Math.round(((stageIndex + (totalInStage ? answered / totalInStage : 0)) / Math.max(1, stages.length)) * 100)}%`,
                }}
              />
            </div>
            <div className="idea-preview-qcount">
              Question {Math.min(answered + 1, totalInStage)} of {totalInStage}
            </div>
          </div>

          <div className="idea-preview-current">
            <div className="idea-preview-current-label">Current question</div>
            <div className="idea-preview-current-text">{currentQ}</div>
            <div className="idea-preview-hint">Answer in the chat box below — replies stay in the Preview panel progress.</div>
          </div>

          <div className="idea-preview-stages">
            {stages.map((s, i) => (
              <div
                key={s.stage}
                className={`idea-preview-chip ${i === stageIndex ? 'on' : ''} ${i < stageIndex ? 'done' : ''}`}
              >
                {i < stageIndex ? '✓ ' : ''}{s.stage}
              </div>
            ))}
          </div>

          {allAnswers.length > 0 && (
            <div className="idea-preview-answers">
              <div className="idea-preview-answers-title">Your answers so far</div>
              {allAnswers.map((a) => (
                <div key={a.key} className="idea-preview-answer">
                  {a.value}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
